export default "__VITE_ASSET__1Br6R0Hk__"